import NetworkService from "@/services/NetworkService.js";

export default class BankAccountService {
  constructor() {
    this.network = new NetworkService();
  }

  listBankCodes = (params) => {
    return this.network.get("api/bank-codes", params);
  };

  create = (params) => {
    return this.network.post("api/bank-accounts", params);
  };

  list = (userId) => {
    return this.network.get(`api/users/${userId}/bank-accounts`);
  };

  delete = (bankAccountId) => {
    return this.network.delete(`api/bank-accounts/${bankAccountId}`);
  };
}
